/*
 * File: ProgressProvider.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on May 30, 2024 at 11:44 AM
 * Copyright © 2024 Let's Talk. All rights reserved.
 *
 * Last Modified: May 30, 2024 at 11:44 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { useState, useEffect } from 'react';


/**
 * Hook
 */

const ProgressProvider = ({ valueStart, valueEnd, children }) => {

	// Create state handlers
	const [value, setValue] = useState(valueStart);

	// Update state when value ends
	useEffect(() => {
		setValue(valueEnd);
	}, [valueEnd]);

	// Return children
	return children(value);
};


/**
 * Exports
 */

export default ProgressProvider;
